module.exports = __webpack_public_path__ + "img/logo.6d173a7b.png";